<template>
  <div class="modal_card" v-if="!loading">
    <div class="header">
      <h4 class="title">
        {{ task_info.command }} №{{ task_info.id }}
      </h4>
    </div>

    <div class="summary">
      <div class="tab">
                <span
                    class="tab_title"
                    :class="{ active : block==='MainInfo'}"
                    @click="selected_block('MainInfo')"
                >
                    {{ this.translate('task.main_info') }}
                </span>
        <span
            class="tab_title"
            :class="{ active : block==='Params'}"
            @click="selected_block('Params')"
        >
                    {{ this.translate('task.params') }}
                </span>
        <span
            class="tab_title"
            :class="{ active : block==='Logs'}"
            @click="selected_block('Logs')"
        >
                    {{ this.translate('task.logs') }}
                </span>
      </div>

      <div class="block">
        <MainInfo
            v-if="block==='MainInfo'"
            :task_info="task_info"
        />
        <Params
            v-if="block==='Params'"
            :params="params"
        />
        <Logs
            v-if="block==='Logs'"
            :logs="logs"
        />
      </div>
    </div>


    <div class="modal_clients__footer">
      <div class="text-center">

        <button
            type="submit"
            class="btn btn-danger btn-fill btn-wd marginButton"
            @click.prevent="close"
        >
          {{ translate('close_modal') }}
        </button>

        <button
            v-if="task_info.status === 'Error'"
            type="submit"
            class="btn btn-success btn-fill btn-wd marginButton"
            @click.prevent="complete_task()"
        >
          {{ translate('task.complete_task') }}
        </button>

      </div>
    </div>
  </div>

  <div v-else style="height: 100%">
    <div class="spinner">
      <scale-loader/>
    </div>
  </div>
</template>
<script>

import MainInfo from "./Tabs/MainInfo.vue";
import Params from "./Tabs/Params.vue";
import Logs from "./Tabs/Logs.vue";

export default {
  name: "TaskModal",
  components: {
    MainInfo,
    Params,
    Logs
  },
  props: ['task_id'],
  data() {
    return {
      task_info: {},
      options: {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      },
      block: 'MainInfo',
      loading: true
    }
  },

  computed: {
    params() {
      return this.task_info.params
    },
    logs() {
      return this.task_info.log
    }
  },

  created() {
    this.init()
  },

  destroyed() {
    history.pushState(null, null, this.$route.fullPath)
    if (this.$route.query.task_id) {
      let new_window = this.$route.fullPath.replace('?task_id=' + this.$route.query.task_id, '')
      this.$router.push(new_window)
    }
  },

  methods: {
    selected_block(block) {
      this.block = block
    },
    init() {
      this.$http.v1.getDeviceTaskInfo(this.task_id, (response) => {
        this.task_info = response.data
        this.loading = false
      })
    },
    close() {
      this.$emit('close')
    },
    complete_task() {
      this.$http.v1.updateStatusTask(this.task_id, {status: 6}, () => {
        this.global_notify('info', this.translate('task.state.complete'))
        this.$emit('update')
      })
    }

  }
}
</script>
<style lang="scss" scoped>
.modal_card {
  width: 100%;
  border-radius: 3px;
  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
  color: #252422;
  position: relative;
  border: 1px solid #ccc;
  min-height: 85px;
  background-color: #f8f8f8;
  padding: 10px;

  .header {
    text-align: center;

    .title {
      margin-top: 15px;
    }

  }

  .summary {
    height: 600px;

    .tab {
      width: 100%;
      height: 30px;
      display: flex;
      align-content: center;
      justify-content: center;
      flex-direction: row;

      &_title {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        padding: 5px 0;
        cursor: pointer;
        font-weight: 600;
        font-size: 14px;
        text-align: center;
        background-color: #efe9e9;
        border: 1px solid #efe9e9;

        &.active {
          background-color: #f8f8f8;
          border-bottom: 1px solid #f8f8f8;
        }
      }
    }

    .block {
      height: 95%;
      border: 1px solid #efe9e9;
      margin-top: -1px;
      padding: 10px 0;
      overflow: auto;

      &::-webkit-scrollbar {
        width: 10px;
      }
    }
  }
}

</style>
